import { Style, ThreeDots } from "react-loader-spinner";

interface Props {
  height?: number;
  width?: number;
  wrapperStyle?: Style;
  wrapperClass?: string;
}
const DefaultNTILoader: React.FC<Props> = ({
  height,
  width,
  wrapperStyle,
  wrapperClass
}) => (
  <ThreeDots
    wrapperStyle={wrapperStyle}
    wrapperClass={wrapperClass}
    color="#000"
    height={height ?? 20}
    width={width ?? 20}
  />
);

export default DefaultNTILoader;
